import type { HttpClient } from './HttpClient';
import type { ApiClient } from './ApiClients';

export class ApiClientJson implements ApiClient<object> {
  constructor(private httpClient: HttpClient) {}

  async post<T>(path: string, body: object): Promise<T> {
    return this.httpClient.fetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }) as Promise<T>;
  }

  async delete(path: string): Promise<void> {
    return this.httpClient.fetch(path, {
      method: 'DELETE',
    });
  }

  async patch<T>(path: string, body: object): Promise<T> {
    return this.httpClient.fetch(path, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }) as Promise<T>;
  }
}
